import { Box, Divider, Grid, Paper, Typography } from '@mui/material'

import ToothGraphic5 from '@/assets/images/Tooth-graphic-5.svg'
import PieChart from '@/components/PieChart'
import {
  ALL_IN_ONE_REGIONS,
  allInOneRecipeChart,
  getOpaquerAdvice,
} from '@/utils/matisseV2/allInOne'

function OpaquerPDF({ recipe }) {
  if (recipe?.provided_input?.indication !== 'PFM Crown') {
    return null
  }

  const titles: Record<string, string> = {
    cervical: 'Cervical',
    middle: 'Middle',
    incisal: 'Incisal',
  }

  return (
    <Paper
      id="download-page-0"
      elevation={0}
      sx={{
        backgroundColor: '#FFF',
        px: 5,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        flexGrow: 1,
      }}
    >
      <Grid container sx={{ height: '100%' }}>
        <Grid item xs={4} sx={{ backgroundColor: 'white' }}>
          <Box
            component="img"
            src={ToothGraphic5}
            alt="Toothimage"
            sx={{ width: '233px', height: '330px' }}
          />
        </Grid>

        <Grid
          item
          xs={8}
          container
          alignItems="center"
          sx={{
            backgroundColor: 'white',
            color: 'black',
            flexGrow: 1,
          }}
        >
          {ALL_IN_ONE_REGIONS.map((region) => {
            const chart = allInOneRecipeChart(getOpaquerAdvice(recipe, region))
            if (!chart.labels.length) return null
            return (
              <Grid item xs={4} key={region}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  m={3}
                >
                  <Typography
                    variant="h6"
                    component="div"
                    sx={{ color: 'black', fontWeight: 'bold' }}
                  >
                    {titles[region]}
                  </Typography>
                </Box>
                <PieChart
                  labels={chart.labels}
                  values={chart.values as number[]}
                />
              </Grid>
            )
          })}
        </Grid>
      </Grid>

      <Divider sx={{ backgroundColor: 'black', opacity: 1 }} />
    </Paper>
  )
}

export default OpaquerPDF
